// extracted by mini-css-extract-plugin
module.exports = {"StatisticsPieChart":"styles_StatisticsPieChart__9tNCj","height":"styles_height__biLI7"};